/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'CHEMICAL_STORAGE_AREAS_ARE_APPROPRIATELY_DESIGNED_CONSTRUCTED_A',
              'CHEMICAL_STORAGE_AREAS_HAVE_MEASURES_IN_PLACE_TO_PREVENT_UNAUTH',
              'WHEN_NOT_IN_USE_ALL_CHEMICAL_CONTAINERS_ARE_PROPERLY_CAPPED_AND',
              'CHEMICAL_STORAGE_AREAS_WITH_FLAMMABLE_CHEMICALS_ARE_EQUIPPED_WI',
              'IN_CASES_OF_EMERGENCY_THERE_ARE_EASY_ENTRY_IES_AND_EXIT_S_TO_AL',
              'CHEMICAL_STORAGE_AREAS_HAVE_AN_ALARM_NOTIFICATION_SYSTEM',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_additional_safety_measures_in_place_relat: valueSchema,
  },
}
